export default __webpack_public_path__ + "static/media/waterfalls1.0831daba.webp";